
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";

export default function Dashboard() {
  const navigate = useNavigate();
  const { isGuest, logoutGuest } = useContext(AuthContext);

  const handleLogout = () => {
    if (isGuest) {
      logoutGuest();
    } else {
      signOut(auth);
    }
    navigate("/");
  };

  return (
    <div style={{ padding: "1.5rem" }}>
      <h1>Classroom Companion</h1>
      {isGuest && (
        <div style={{ background: "#e3f2fd", border: "1px solid #2196f3", padding: "12px", borderRadius: "4px", marginBottom: "16px" }}>
          👋 <strong>Welcome, Recruiter!</strong> You're viewing a demo account with sample data. Email <a href="mailto:ghamilton@mrhamilton.me">ghamilton@mrhamilton.me</a> for more information.
        </div>
      )}
      <p>Welcome to the pilot. Use the links below to get started and report issues.</p>

      <section style={{ marginBottom: "1.5rem" }}>
        <h2>Quick start</h2>
        <ol>
          <li>Create or open a class.</li>
          <li>Open Seating Plan to arrange desks.</li>
          <li>Use Teaching Mode to log behaviour, objectives, and attendance.</li>
          <li>Check Analytics for trends and attendance.</li>
        </ol>
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <Link to="/classes">Go to Classes</Link>
          <Link to="/feedback">Report an issue</Link>
        </div>
      </section>

      <section style={{ marginBottom: "1.5rem" }}>
        <h2>Help</h2>
        <p>If something looks wrong, please submit feedback with as much detail as possible.</p>
      </section>

      <section style={{ marginBottom: "1.5rem" }}>
        <h2>Policies</h2>
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <Link to="/privacy">Privacy notice</Link>
          <Link to="/retention">Retention policy</Link>
          <Link to="/compliance">Compliance baseline</Link>
          <Link to="/ropa">ROPA</Link>
          <Link to="/dpia">DPIA outline</Link>
        </div>
      </section>

      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}